import {Modal} from "react-bootstrap"
import * as Icon from "react-feather"

const ErrorPopup = ({title, message, open, onClose}) => {
    return <>
        <Modal
            show={open}
            onHide={onClose}
            centered
        >
            <Modal.Header className="bg-danger text-white" closeButton>
                <Icon.AlertTriangle className="pr-2"/> {title}
            </Modal.Header>
            <Modal.Body className="pt-5 pb-5">
                {message}
            </Modal.Body>
        </Modal>
    </>
}

export default ErrorPopup